import _ from 'lodash';
import { IAgent, IAgentMultiUser } from '@/types';
import { SDK } from '../constants';

/** TODO: We might request app status and agent sequentially? */
export const useGetAgents = () => {
  /**
   * If HITL app is not ready - we can't use "Get Complete Agent" API,
   * instead we should use Users-SDK.
   */
  const getAgent = async (args: { userId: string; multiUserId?: string; }) => {
    try {
      return await SDK.HITL.agents.getCompleteAgentById({
        agentId: args.userId,
        multiUserId: args.multiUserId,
      }) as IAgent;
    } catch (e) {
      return await getAgentHttpSDK(args);
    }
  };

  const getAgentHttpSDK = async (args: {
    userId: string;
    multiUserId?: string;
  }) => {
    const { userId, multiUserId } = args;
    /* Use mock request to infer correct types */
    const multiUserRequest = multiUserId
      ? SDK.HttpSDK.multiusers.getProfileById(multiUserId) as Promise<IAgentMultiUser>
      : Promise.resolve({} as IAgentMultiUser);

    const [user, multiuser] = await Promise.all([
      SDK.HttpSDK.multiusers.getUserById(userId, []),
      multiUserRequest,
    ]);

    /* Properties that are used in header */
    const properties = ['firstName', 'lastName'];
    const profile = multiuser?.data?.profile || {};
    const email = multiuser?.email || user.email;

    /* Multi-user's values have priority over normal user's */
    const primary = _.pick(profile, properties);
    const secondary = _.pick(user.data, properties);
    const data = Object.assign({}, secondary, primary);

    const agent = {} as IAgent;
    return Object.assign(agent, user, { data, email });
  };

  return { getAgent };
};
